import React from "react";
import {
  FreePastPerformanceWrapper,
  Title,
  PastPerformanceLine,
  TitleContainer,
  DocumentFormat,
  DownloadLink
} from "./styled-components";

export interface FreePastPerformanceProps {
  onDownload: CallableFunction;
  title: string;
  isMobile: boolean;
  fppSectionContent: Record<string, string>;
  isLegView?: boolean;
}

const FreePastPerformance = (props: FreePastPerformanceProps) => (
  <FreePastPerformanceWrapper
    isMobile={props.isMobile}
    isLegView={props.isLegView}
    data-qa-label="past-performance-container"
  >
    <Title>{props.fppSectionContent.title}</Title>

    <PastPerformanceLine>
      <TitleContainer>
        {props.title}
        <DocumentFormat>
          {props.fppSectionContent.documentFormat}
        </DocumentFormat>
      </TitleContainer>

      <DownloadLink
        data-qa-label="past-performance-download"
        onClick={() => props.onDownload()}
      >
        {props.fppSectionContent.action}
      </DownloadLink>
    </PastPerformanceLine>
  </FreePastPerformanceWrapper>
);

export default FreePastPerformance;
